import { makeAutoObservable, toJS } from 'mobx';

export const getInitialFormValues = (inputs: any) => {
  const values: any = {};

  inputs?.forEach((input: any) => {
    values[input.name] = '';
  });

  return values;
};

interface OpenDrawerProps {
  label: string;
  inputs: any[];
  clickCallback?: () => void;
  buttonLabel?: string;
  showButton?: boolean;
  saveWithoutReset?: boolean;
}

export class DrawerStore {
  private _open = false;
  private _label = '';
  private _inputs: any[] = [];
  private _values: any = {};
  private _buttonLabel?: string;
  private _showButton = true;
  private _saveWithoutReset = false;

  private saveCallback?: () => void;
  private resetCallback?: () => void;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  reset() {
    this._open = false;
    this._values = {};
    this._inputs = [];
    this._label = '';
    this.saveCallback = undefined;
    this._saveWithoutReset = false;
    if (this.resetCallback) this.resetCallback();
  }

  openDrawer({
    label,
    inputs,
    clickCallback,
    buttonLabel,
    showButton = true,
    saveWithoutReset = false,
  }: OpenDrawerProps) {
    this._label = label;
    this._inputs = inputs;
    this.saveCallback = clickCallback;
    this._buttonLabel = buttonLabel;
    this._showButton = showButton;
    this._saveWithoutReset = saveWithoutReset;

    if (!buttonLabel) {
      this._buttonLabel = 'Save';
    }

    this._open = true;
  }

  setValues(values: any) {
    this._values = toJS(values);
  }

  setInputs(inputs: any) {
    this._inputs = toJS(inputs);
  }

  updateInputOptions(name: string, newList: any[]) {
    const thisInput = this._inputs.find((input) => input.name === name);
    if (thisInput) {
      thisInput.options = newList;
    }
  }

  setLabel(label: string) {
    this._label = label;
  }

  setCallback(callback: () => void) {
    this.saveCallback = callback;
  }

  setResetCallback(callback: () => void) {
    this.resetCallback = callback;
  }

  setButtonLabel(buttonLabel: string) {
    this._buttonLabel = buttonLabel;
  }

  setSaveWithoutReset(saveWithoutReset: boolean) {
    this._saveWithoutReset = saveWithoutReset;
  }

  get open() {
    return toJS(this._open);
  }

  get inputs() {
    return toJS(this._inputs);
  }

  get label() {
    return toJS(this._label);
  }

  get buttonLabel() {
    return toJS(this._buttonLabel);
  }

  get values() {
    return toJS(this._values); // Need to convert if mobxData is array
  }

  get showButton() {
    return toJS(this._showButton);
  }

  async save() {
    if (this.saveCallback) {
      await this.saveCallback();
    }
    if (!this._saveWithoutReset) {
      this.reset();
    } else {
      this._saveWithoutReset = false;
    }
  }
}

export const drawerStore = new DrawerStore();
